<template>
    <div>
        <div class="row col-12">
            <div class="depoimentos">
                <div class="col-11 offset-1">
                    <div id="tituloDepoimentos"><h1 class="textoNossosServicos ml-4">Cartórios na mídia</h1></div>
                </div>

                <div class="ml-4 mt-4">
                    <div class="col-12 text-center ml-4">
                        <div class="row quadros_midia">
                            <div class="col-3">
                                <div class="imgNossoServicos"><img src="~@/assets/imgs/media/exame.png"            class="w-25" /></div>
                            </div>
                            <div class="col-3 ml-4">
                                <div class="imgNossoServicos"><img src="~@/assets/imgs/media/valor.png"            class="w-25" /></div>
                            </div>
                            <div class="col-3 ml-4 mt-2">
                                <div class="imgNossoServicos"><img src="~@/assets/imgs/media/globo.png"      class="w-25" /></div>
                            </div>
                            <div class="col-2  ml-4 mt-2">
                                <div class="imgNossoServicos"><img src="~@/assets/imgs/media/cbn.png"   class="w-25"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 bgcenprot">
            <div class="row ml-4">
                <div class="col-6 offset-1">
                    <h2 class="nacenprot">Na Central Nacional de Protesto (CENPROT) você acessa os serviços de todos os Cartórios de Protesto do Brasil, sem intermediários.</h2>
                    <p class="nacenprotp">Acesse gratuitamente serviços eletrônicos dos cartórios de protesto de todo o país:<br> envio eletrônico de títulos e documentos de dívida, consulta, certidão eletrônica, cancelamento, emissão de carta de anuência digital, verificação de autenticidade de instrumentos e certidões de protesto.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
   
    
}
</script>
<style scoped>
.tituloCardDepoimentos{
    color: #69A9Fc;
    font-weight: bold;
    font-size: 16;
}
.textoNossosServicos
{
  color: #084f84;
  font-size: 29px;
  line-height: 25px;
  /* margin-right: 500px; */
  text-align: left;
  font-weight: bold;
}
@media (min-width: 900px) {
  .textoNossosServicos
  {
    color: #084f84;
    font-size: 35px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
  }
}
.depoimentos{
    margin-top: 80px;
    height:250px;
}
.quadros_midia{
    margin-top: calc(5%);
}
.bgcenprot
{
    background-image: url("~@/assets/imgs/cenprot-mobile.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}
@media (min-width: 900px) {
  .bgcenprot
  {
    background-image: url("~@/assets/imgs/cenprot.png");
    height:600px;
  }
}
.nacenprot{
    margin-top: calc(15%);
    font-size: 39px;
    color:white;
    font-weight: bold;
    line-height: 60px;
}
.nacenprotp{
    margin-top: calc(5%);
    font-size: 39px;
    font-size: 17px;
    color:white;
    font-weight: bold;
}



</style>